import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'datePipe'})
export class DatePipe implements PipeTransform {

  transform(value: string, datetime: boolean = false, isLocalDate: boolean = false) {
    const date = moment(value).utc(!isLocalDate);

    if (datetime) {
      return date.format('HH:mm/DD-MMM-YYYY');
    } else {
      return date.format('DD-MMM-YYYY');
    }
  }
}
